<template>
  <div class="list">
    <div class="list-filter">
      <el-form :inline="true" :model="queryEntity" class="demo-form-inline">
        <el-form-item label="编码">
          <el-input size="small" v-model="queryEntity.code" placeholder="订单编码"></el-input>
        </el-form-item>
        <el-form-item label="名称">
          <el-input size="small" v-model="queryEntity.name" placeholder="订单名称"></el-input>
        </el-form-item>
        <el-form-item label="用户名称">
          <el-input size="small" v-model="queryEntity.creator" placeholder="订单用户名称"></el-input>
        </el-form-item>
        <el-form-item label="创建日期">
          <el-date-picker size="small" v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="YYYY-MM-DD HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态">
          <el-select class="list-filter-state" clearable v-model="queryEntity.state" size="small" placeholder="全部状态" style="width:140px">
            <el-option v-for="item in states" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="list-btn-select" size="small" type="primary" @click="selectList">查询</el-button>
          <el-button class="list-btn-reset" size="small" @click="resetSelect">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="list-tool cf">
      <div class="fl">
        <el-button class="list-btn" size="small" type="danger" :disabled="disableAuth('delete')" @click="deleteList">批量删除</el-button>
      </div>
      <div class="fr">
      </div>
    </div>
    <div class="list-table">
      <el-table :data="dataList" :header-cell-class-name="headerCellClass" :max-height="tableHeight" stripe @selection-change="handleSelectionChange" size="medium">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="no" label="序号" width="50" fixed> </el-table-column>
        <el-table-column prop="code" label="订单编码" width="120" fixed> </el-table-column>
        <el-table-column prop="name" label="订单名称" width="220" fixed> </el-table-column>
        <el-table-column prop="insCoName" label="送检单位名称" width="220"> </el-table-column>
        <el-table-column prop="certCoName" label="证书单位名称" width="220"> </el-table-column>
        <el-table-column prop="stateName" label="状态" width="120"> </el-table-column>
        <el-table-column prop="creator" label="用户名称" width="100"> </el-table-column>
        <el-table-column prop="createTime" label="订单创建时间" width="160"> </el-table-column>
        <el-table-column prop="remark" label="备注"> </el-table-column>
        <el-table-column fixed="right" label="操作" width="210">
          <template #default="scope">
            <el-button type="primary" size="mini" :disabled="disableAuth('view')" @click="view(scope)">查看</el-button>
            <el-button type="success" size="mini" :disabled="disableAuth('modify')" @click="modify(scope)">修改</el-button>
            <el-button type="danger" size="mini" :disabled="disableAuth('delete')" @click="deleteItem(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="list-pager">
      <el-pagination class="list-pager-inner" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" v-model:currentPage="queryParam.pager.pageIndex" v-model:page-size="queryParam.pager.pageSize" :total="queryParam.pager.total" layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script lang="ts">
import { Inspect } from "@/script/apps/inspect/entity/InspectEntity";

import { ElMessage } from "element-plus";
import { Options } from "vue-class-component";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { InspectService } from "@/script/apps/inspect/service/InspectService";

@Options({})
export default class InspectList extends BaseList {
  private queryEntity: Inspect = {};

  private dataList: Inspect[] = [];

  private service = new InspectService();

  private dateRange: string[] = [];

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_ins_inspect",
      "/ins/inspect",
      "/ins/inspect",
      this.service
    );
    data.statesName = "ins-order-state";
    return data;
  }

  public initQueryEntity() {
    this.queryEntity = {
      code: "",
      name: "",
    };
    this.queryParam.pager!.sorters = [];
    this.queryParam.pager!.sorters.push({
      prop: "createTime",
      sortField: "create_time",
      sortMode: "desc",
    });
    this.dateRange = [];
    return this.queryEntity;
  }

  public initParam() {
    const param = this.$route.query;
    if (param.state) {
      this.queryEntity.state = String(param.state);
    }
  }

  public beforeLoadList() {
    if (this.queryEntity.state === "") {
      this.queryEntity.state = null;
    }
    if (this.dateRange && this.dateRange.length > 0) {
      this.dateRange[1] = this.dateRange[1].replace("00:00:00", "23:59:59");
      this.queryParam.extendMap = {
        beginTime: this.dateRange[0],
        endTime: this.dateRange[1],
      };
    } else {
      this.queryParam.extendMap = {};
    }
  }

  public afterLoadList(data: any): void {
    const currDataList: Inspect[] = data.list as Inspect[];
    currDataList.forEach((item) => {});
    this.dataList = currDataList;
  }
}
</script>
